import { Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'

import FacilitationHeader from 'components/FacilitationHeader'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import Section2Title from 'components/Section2Title'
import UserEducationModal from 'components/UserEducationModal'

import { styles } from './Section2.styles'

export const TEST_ID = 'view-master-section2'

export type Props = {
	generatePromptsDisabled: () => boolean
	imageData: string | null
	loading: boolean
	refreshImage: () => void
}

const Section2 = (props: Props) => {
	return (
		<>
			<Section2Title showInfoPopper={false} />
			<UserEducationModal />
			<Box style={styles.mainBox}>
				<Box sx={styles.sideBar} />
				<Box sx={styles.typographyBox}>
					<Typography
						sx={styles.typography}
						data-testid={`${TEST_ID}-user-directions-verbiage`}
					>
						Consider these GenAI visualizations of your idea a
						couple years in the future.
						{props.loading && !props.imageData && (
							<Box
								component="span"
								role="status"
								sx={styles.loadingSupportText}
								data-testid={`${TEST_ID}__loading-support-text`}
							>
								Thank you for your patience. Image generation
								can take a little longer to load.
							</Box>
						)}
					</Typography>
					<FacilitationHeader
						onRefresh={props.refreshImage}
						isLoading={
							props.loading || props.generatePromptsDisabled()
						}
						refreshTestId={`${TEST_ID}__refresh-button`}
						editTestId={`${TEST_ID}-edit-prompt`}
					/>
					{props.loading && !props.imageData ? (
						<LoadingSpinner />
					) : props.imageData ? (
						<Paper
							elevation={0}
							sx={styles.paper}
							data-testid={`${TEST_ID}__company-disruption`}
						>
							<Box
								component="img"
								alt="AI-generated future visualization of the innovation idea"
								src={`data:image/png;base64,${props.imageData}`}
								sx={styles.image}
								data-testid={`${TEST_ID}__image`}
							/>
						</Paper>
					) : null}
				</Box>
			</Box>
		</>
	)
}

export default Section2
